import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { echoAuthApi } from '../services/authApi';

window.Pusher = Pusher;


const echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    forceTLS: false,
    authorizer: (channel) => ({
        authorize: async (socketId, callback) => {
            const token = localStorage.getItem('authToken');
            const tokenType = localStorage.getItem('tokenType') || 'Bearer';

            if (!token) {
                const error = new Error('Missing auth token for broadcasting auth request');
                console.error('[Echo] Broadcasting auth failed:', error);
                callback(error, null);
                return;
            }

            try {
                const response = await echoAuthApi(socketId, channel.name);;

                callback(null, response.data);
            } catch (error) {
                console.error('[Echo] Broadcasting auth error:', error?.response || error);
                callback(error, null);
            }
        },
    }),
});

export default echo;